import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { ApplyForLeavesDTO } from './dto/apply-for-leaves.dto';
import { ApplyForLeavesService } from './apply-for-leaves.service';
import { AllApplyForLeavesResponse, ApplyForLeavesResponseModel, GetAllAvailableLeavesResponseModel } from '@gtpl/shared-models/hrms';
import { ApplyForLeavesRequest } from './dto/apply-for-leaves.request';
import { GetAllAvailableLeavesDto } from './dto/get-available-leaves.dto';

@Controller('apply-for-leaves')
@ApiTags('apply-for-leaves')
export class ApplyForLeavesController {
    constructor(
        private service: ApplyForLeavesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }


    @Post('/createLeave')
    async createLeave(@Body() dto: ApplyForLeavesDTO): Promise<ApplyForLeavesResponseModel> {
        try {
            return await this.service.createLeave(dto, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel, error);
        }
    }

    @Post('/updateLeave')
    async updateLeave(@Body() dto: ApplyForLeavesDTO): Promise<ApplyForLeavesResponseModel> {
        try {
            return await this.service.createLeave(dto, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel, error);
        }
    }

    @Post('/getAllAppliedLeaves')
    async getAllAppliedLeaves(): Promise<AllApplyForLeavesResponse> {
        try {

            return await this.service.getAllAppliedLeaves();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllApplyForLeavesResponse, error);
        }
    }

    @Post('activateOrDeactivateApplyForLeave')
    async activateOrDeactivateApplyForLeave(@Body() req: ApplyForLeavesRequest): Promise<ApplyForLeavesResponseModel> {
        try {
            return await this.service.activateOrDeactivateApplyForLeave(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel, error);
        }
    }

    @Post('updateLeaveStatus')
    async updateLeaveStatus(@Body() req: ApplyForLeavesRequest): Promise<ApplyForLeavesResponseModel> {
        try {
            return await this.service.updateLeaveStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel, error);
        }
    }




}
